module.exports = __webpack_public_path__ + "static/media/6_EN.57d4ab36.mp3";